module.exports = __webpack_public_path__ + "img/jigsaw.11e918a.svg";